import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFire = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.1846 21.5C16.2439 21.5 19.25 18.6607 19.25 14.7499C19.25 12.4129 18.1567 11.2612 16.5721 9.59209L16.5506 9.56944C15.1103 8.05231 13.4123 6.21775 12.9023 3.01239C12.2407 3.40163 11.5215 3.99923 10.9908 4.77145C10.2042 5.91598 9.84445 7.40534 10.7752 9.26682C11.3778 10.472 11.5515 12.0073 10.4981 13.0606C9.84077 13.718 8.73607 14.1614 7.54198 13.6472C6.79012 13.3234 6.18859 12.6918 5.70441 11.8569C5.13698 12.5634 4.75003 13.5976 4.75 14.75C4.74991 18.5967 8.0378 21.5 12.1846 21.5ZM14.2654 1.62652C14.2481 1.28178 13.9685 1.00171 13.6333 1.08409C11.2958 1.65857 7.02756 5.12573 9.43357 9.93765C9.90694 10.8844 9.82474 11.6127 9.43748 12C8.79787 12.6396 7.5632 12.6841 6.56155 10.1852C6.43059 9.85845 6.06428 9.67611 5.75898 9.85126C4.21177 10.7389 3.25005 12.7118 3.25 14.7499C3.24989 19.579 7.37208 23 12.1846 23C16.9971 23 20.75 19.5624 20.75 14.7499C20.75 11.8113 19.2838 10.2683 17.7441 8.64797C16.1341 6.95355 14.2654 5.17187 14.2654 1.62652Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgFire;
